interface ItemType {
  title?: string;
  details?: (string | ItemType)[];
  description?: string;
  no?: string;
  text?: string;
}

export interface ServiceDataItem {
  title?: string;
  anchor?: string;
  items?: ItemType[];
  description?: string | string[];
  button?: string;
}

export interface ServiceData {
  [x: string]: ServiceDataItem;
}

export const extractTableOfContent = (data: ServiceData, url: string) => {
  const items = Object.entries(data).filter(([_key, value]) => value.anchor);

  return items.map((item) => {
    const value = item[1];
    const key = item[0];

    return {
      id: key,
      title: value.title,
      href: `${url}/#${value.anchor}`,
    };
  });
};
